import { render, staticRenderFns } from "./OracleAccountModuleRoleRow.vue?vue&type=template&id=11cfc47c&"
import script from "./OracleAccountModuleRoleRow.vue?vue&type=script&lang=js&"
export * from "./OracleAccountModuleRoleRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports